import "../../App.css";
import "./Home.css";
import { Link } from "react-router-dom";
import HeroSection from "../HeroSection";
import Footer from "../Footer";
import TextCard from "../TextCard";
import CategoryGrid from "../CategoryGrid";
import PortfolioTeaser from "../PortfolioTeaser";
import Reviews from "../Reviews";
import Reveal from "../Reveal";
import Seo from "../Seo";

function Home() {
  return (
      <>
        <Seo
            title="Van Vlimmeren Feestverhuur — Exclusieve feestdecoratie"
            suffix={false}
            description="Exclusieve feestdecoratie en feestverhuur in Sint Willebrord e.o. — lichtgevende cijfers & letters, LED-dansvloer, ballondecoratie en photobooth."
            path="/"
        />
        <HeroSection/>
        <Reveal>
          <TextCard
              imageUrl={process.env.PUBLIC_URL + "/images/over_ons.webp"}
              title="01 — Over ons"
              subtitle="Met aandacht voor elk detail"
              text={
                "Bent u bezig met het organiseren van een feest of evenement en kunt u hier wel wat hulp bij gebruiken? Dan bent u bij Van Vlimmeren Feestverhuur aan het juiste adres.\n\nTevens verhuren wij diverse feestartikelen."
              }
              pullQuote="Wij nemen uw zorg over de aankleding geheel uit handen."
          />
        </Reveal>
        <Reveal as="section" className="home-trust" aria-label="Waarom Van Vlimmeren">
          <ul className="home-trust-list">
            <li>Persoonlijke aanpak</li>
            <li className="home-trust-dot" aria-hidden="true">·</li>
            <li>Decoratie op maat</li>
            <li className="home-trust-dot" aria-hidden="true">·</li>
            <li>24/7 bereikbaar</li>
          </ul>
        </Reveal>
        <Reveal
          as="section"
          className="home-breaker"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images-v2/cijfers-en-letters/hero.webp)`,
          }}>
          <p className="home-breaker-line">
            Van intieme verjaardagen tot grootse bedrijfsfeesten
          </p>
        </Reveal>
        <Reveal className="reveal--stagger">
          <CategoryGrid
              eyebrow="02 — De collectie"
              title="Voor elk feest, op maat"
          />
        </Reveal>
        <Reveal className="reveal--stagger">
          <PortfolioTeaser/>
        </Reveal>
        <Reveal>
          <Reviews/>
        </Reveal>
        <Reveal as="section" className="home-cta">
          <div className="home-cta-inner">
            <span className="home-cta-eyebrow">AANVRAAG</span>
            <h2 className="home-cta-title">Uw feest begint hier</h2>
            <p className="home-cta-text">
              Stel uw aanvraag samen — wij nemen binnen 24 uur contact met
              u op.
            </p>
            <Link
              to="/aanvraag"
              className="btn btn--primary btn--on-dark btn--lg">
              Start uw aanvraag
            </Link>
          </div>
        </Reveal>
        <Footer/>
      </>
  );
}

export default Home;
